// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { getBackGroundStyle, isMobileWeb, isCanada } from '@tcp/core/src/utils';
import { hideProductOriginalPrice } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/views/ProductGridItem.util';
import RatingAndReviews from '@tcp/core/src/components/common/molecules/DyRecommendations/views/RatingsAndReviews.view';
import { getProductListToPath } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/utils/productsCommonUtils';
import {
  IMG_DATA_PLP,
  VID_DATA_SLP,
} from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/config';
import Promotions from '@tcp/core/src/components/features/browse/BundleProduct/atoms/Promotions';
import {
  getIconPath,
  getVideoUrl,
  getDynamicBadgePackQty,
  getStringAcronym,
} from '@tcp/core/src/utils/utils';
import ImageComponent from '@tcp/core/src/components/features/browse/BundleProduct/atoms/Image';
import Image from '@tcp/core/src/components/common/atoms/Image';
import Price from '@tcp/core/src/components/common/molecules/DyRecommendations/views/Price.view';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import Constants from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.constants';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import LabelsContext from '@tcp/core/src/components/common/context/LabelsContext';
import styles, {
  ImageContainer,
  PriceSection,
  ATBIcon,
  Title,
} from '@tcp/core/src/components/common/molecules/RecommendationCarousel/styles/RecommendationTile.style';

const renderImage = ({
  imageUrl,
  dynamicBadgeOverlayQty,
  pdpAsPath,
  pdpToPath,
  name,
  tcpStyleType,
  primaryBrand,
  isTransparentImageSizeReduceEnabled,
  backGroundStyle,
}) => {
  const isVideoUrl = imageUrl && getVideoUrl(imageUrl);
  const mainConfig = isVideoUrl ? VID_DATA_SLP.imgConfig : IMG_DATA_PLP.imgConfig;
  const isPngImage = /\.png$/i.test(imageUrl);
  return (
    <ImageContainer className="recommendation-tile-image" style={backGroundStyle}>
      <ImageComponent
        pdpAsPath={pdpAsPath}
        pdpToPath={pdpToPath}
        dynamicBadgeOverlayQty={dynamicBadgeOverlayQty}
        mainConfig={mainConfig}
        isVideoUrl={isVideoUrl}
        imageData={{ alt: name, url: imageUrl }}
        TCPStyleType={tcpStyleType}
        badgeConfig={IMG_DATA_PLP.badgeConfig}
        primaryBrand={primaryBrand}
        lazyLoadImage
        isTransparentImageSizeReduceEnabled={isTransparentImageSizeReduceEnabled}
        isPngImage={isPngImage}
      />
    </ImageContainer>
  );
};

const renderPrice = ({
  currencySymbol,
  currencyAttributes,
  listPrice,
  offerPrice,
  merchantTag,
  isHideOriginalPrice,
}) => {
  return (
    <Price
      minListPrice={listPrice}
      minOfferPrice={offerPrice}
      merchantTag={merchantTag}
      isHideOriginalPrice={isHideOriginalPrice}
      currencyAttributes={currencyAttributes}
      currencySymbol={currencySymbol}
    />
  );
};

const renderATBIcon = ({
  name,
  handleClick,
  productId,
  isBagPage,
  bagItemCount,
  isAddedToBag,
  orderItemsCount,
  spcBag,
}) => {
  return (
    <ATBIcon
      onClick={() => handleClick(productId)}
      aria-label={`View quick details for ${name}`}
      aria-haspopup="dialog"
      isBagPage={isBagPage}
      bagItemCount={bagItemCount}
      isAddedToBag={isAddedToBag}
      orderItemsCount={orderItemsCount}
      spcBag={spcBag}
      className="recommendation-tile-atc-icon"
    >
      <Image
        className="atb-icon-image"
        src={getIconPath('add-to-bag-icon-blue')}
        aria-hidden={true}
        alt=""
      />
    </ATBIcon>
  );
};

export const renderPriceSection = ({
  currencySymbol,
  currencyAttributes,
  listPrice,
  offerPrice,
  merchantTag,
  isHideOriginalPrice,
  name,
  handleClick,
  productId,
  isBagPage,
  bagItemCount,
  isAddedToBag,
  orderItemsCount,
  spcBag,
}) => {
  return (
    <PriceSection>
      {renderPrice({
        currencySymbol,
        currencyAttributes,
        listPrice,
        offerPrice,
        merchantTag,
        isHideOriginalPrice,
      })}
      {renderATBIcon({
        name,
        handleClick,
        productId,
        isBagPage,
        bagItemCount,
        isAddedToBag,
        orderItemsCount,
        spcBag,
      })}
    </PriceSection>
  );
};

const renderTitle = ({ pdpToPath, pdpAsPath, name }) => {
  return (
    <Anchor to={pdpToPath} asPath={pdpAsPath}>
      <Title fontFamily="secondary" fontSize="fs12" className="product-name">
        {name}
      </Title>
    </Anchor>
  );
};

const renderPromotions = ({
  promotionsData,
  TCPPromotionPrice,
  TCPPromotionID,
  isUpdatedPromotionsDisplayEnabled,
  serverTime,
}) => {
  return (
    <Promotions
      promotionsData={promotionsData}
      TCPPromotionPrice={TCPPromotionPrice}
      TCPPromotionID={TCPPromotionID}
      isUpdatedPromotionsDisplayEnabled={isUpdatedPromotionsDisplayEnabled}
      serverTime={serverTime}
      isFormRecommendationTile
    />
  );
};

export const renderRatings = ({ ratings, reviewsCount }) => {
  return <RatingAndReviews ratings={ratings} reviewsCount={reviewsCount} />;
};

const renderLastPurchasedSize = ({ lastPurchasedSize }) => {
  return (
    <BodyCopy
      component="div"
      fontSize={isMobileWeb() ? 'fs10' : 'fs11'}
      fontWeight="normal"
      fontFamily="secondary"
      color="gray.800"
    >{`Last Purchased ${lastPurchasedSize}`}</BodyCopy>
  );
};
const buildNewPdpToPath = ({
  pdpToPath,
  headerLabel,
  page,
  productCrossSellDriver,
  recommendationSelector,
  recSlotId,
}) => {
  return (
    pdpToPath &&
    `${pdpToPath}&viaModule=${
      Constants.RECOMMENDATION
    }&viaPage=${page}&dataSource=recommendation&recommendationCarousel=${
      headerLabel || ''
    }&productCrossSellDriver=${productCrossSellDriver}&recommendationSelector=${recommendationSelector}&recSlotId=${recSlotId}`
  );
};

const RecommendationTile = ({
  className,
  product,
  isHideOriginalPriceAndMarchantTagEnabled,
  headerLabel,
  page,
  currencySymbol,
  currencyAttributes,
  onQuickViewOpenClick,
  isAddedToBag,
  isBackToQuickviewCTAEnabled,
  isQvModalOpen,
  closeQvModal,
  promotionsData = {},
  serverTime,
  isPromoMsgEnabledRecommendation,
  isDynamicBadgeEnabledAbtest,
  isTransparentImageSizeReduceEnabled,
  bagItemCount,
  orderItemsCount,
  spcBag,
  isBagPage,
  fromPageBranch,
  recommendationSelector,
  sendTrackEventsToDy,
  index,
  totalProductsCount,
}) => {
  const {
    generalProductId,
    lastPurchasedSize,
    ratings,
    reviewsCount,
    tcpStyleQty,
    tcpStyleType,
    TCPMerchantTagCanadaStore,
    TCPMerchantTagUSStore,
    TCPPrimaryBrandCanadaStore,
    TCPPrimaryBrandUSStore,
    ProductImage,
    seotoken,
    is_hard_mark_enable: hardMarkDown,
    name,
    price,
    salePrice,
    productFamily,
    promo_id: TCPPromotionID,
    promo_price: TCPPromotionPrice,
    dyRecsId,
    recSlotId,
    decsId,
  } = product;
  const contextExtraConfig = React.useContext(LabelsContext)?.extraConfig || {};

  const imageUrl = `${productFamily}/${ProductImage}`;
  const badge3 = isCanada() ? TCPMerchantTagCanadaStore : TCPMerchantTagUSStore;
  const primaryBrand = isCanada() ? TCPPrimaryBrandCanadaStore : TCPPrimaryBrandUSStore;
  const pdpUrl = `/p/${seotoken}`;

  const isHideOriginalPrice = hideProductOriginalPrice(
    hardMarkDown,
    isHideOriginalPriceAndMarchantTagEnabled
  );
  const isUpdatedPromotionsDisplayEnabled = true;

  const dynamicBadgeOverlayQty = getDynamicBadgePackQty(
    tcpStyleType,
    tcpStyleQty,
    isDynamicBadgeEnabledAbtest
  );

  const pdpToPath = getProductListToPath(pdpUrl);

  let productCrossSellDriver = '';
  if (dyRecsId) {
    const carouselNameAcrynm = getStringAcronym(headerLabel);
    productCrossSellDriver = `${dyRecsId}-${carouselNameAcrynm}-dy`;
  }
  const newPdpToPath = buildNewPdpToPath({
    pdpToPath,
    headerLabel,
    page,
    productCrossSellDriver,
    recommendationSelector,
    recSlotId,
    decsId,
  });

  const handleClick = (colorProductId) => {
    if (isBackToQuickviewCTAEnabled && isAddedToBag && isQvModalOpen && closeQvModal) {
      closeQvModal();
    }
    if (recSlotId) {
      sendTrackEventsToDy({ recSlotId, decsId });
    }

    requestAnimationFrame(() => {
      onQuickViewOpenClick({
        colorProductId,
        fromPage: page,
        fromPageBranch, // this is undefined, we added same  as in monetate. will check later on this
        ...(productCrossSellDriver && { productCrossSellDriver }),
      });
    });
  };

  const backGroundStyle = getBackGroundStyle(
    contextExtraConfig,
    isTransparentImageSizeReduceEnabled,
    imageUrl
  );

  return (
    <div
      className={`${className} recommendation-tile`}
      role="group"
      aria-roledescription="slide"
      aria-label={`${name}. Product ${index + 1} of ${totalProductsCount}`}
      tabIndex="-1"
    >
      {renderImage({
        imageUrl,
        dynamicBadgeOverlayQty,
        pdpAsPath: pdpUrl,
        pdpToPath: newPdpToPath,
        name,
        tcpStyleType,
        primaryBrand,
        isTransparentImageSizeReduceEnabled,
        backGroundStyle,
      })}
      {renderPriceSection({
        currencySymbol,
        currencyAttributes,
        listPrice: price,
        offerPrice: salePrice,
        merchantTag: badge3,
        isHideOriginalPrice,
        name,
        handleClick,
        productId: generalProductId,
        isAddedToBag,
        bagItemCount,
        orderItemsCount,
        spcBag,
        isBagPage,
      })}

      {renderTitle({ pdpToPath: newPdpToPath, pdpAsPath: pdpUrl, name })}
      {renderRatings({ ratings, reviewsCount })}
      {lastPurchasedSize && renderLastPurchasedSize({ lastPurchasedSize })}
      {isPromoMsgEnabledRecommendation &&
        renderPromotions({
          promotionsData,
          TCPPromotionPrice,
          TCPPromotionID,
          isUpdatedPromotionsDisplayEnabled,
          serverTime,
        })}
    </div>
  );
};

RecommendationTile.propTypes = {
  className: PropTypes.string,
  product: PropTypes.shape({}),
  isHideOriginalPriceAndMarchantTagEnabled: PropTypes.bool,
  isDynamicBadgeEnabled: PropTypes.shape({}),
  headerLabel: PropTypes.string,
  page: PropTypes.string,
  currencySymbol: PropTypes.string,
  currencyAttributes: PropTypes.shape({}),
  onQuickViewOpenClick: PropTypes.func.isRequired,
  isTransparentImageSizeReduceEnabled: PropTypes.bool,
};
RecommendationTile.defaultProps = {
  className: '',
  product: {},
  isHideOriginalPriceAndMarchantTagEnabled: false,
  isDynamicBadgeEnabled: {},
  headerLabel: '',
  page: '',
  currencySymbol: '',
  currencyAttributes: {},
  isTransparentImageSizeReduceEnabled: false,
};

export default withStyles(RecommendationTile, styles);

export { RecommendationTile as RecommendationTileVanilla };
